import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'wz-content-loader',
  templateUrl: './content-loader.component.html',
  styleUrls: ['./content-loader.component.scss'],
  standalone: false,
})
export class ContentLoaderComponent implements OnInit {
  public i = 0;
  public frame = 0;

  @Input()
  isCard = false;

  @HostBinding('class.is-absolute')
  @Input()
  isAbsolute = false;

  @Input()
  textPosition: 'top' | 'bottom' = 'bottom';

  constructor() {}

  ngOnInit() {}
}
